// Copyright (c) StrangeBee 2024

import { Route as DescriptionRoute } from './Description';
import { Route as AttachmentListRoute, RouteAttachment as AttachmentSectionListRoute } from './Attachments/List'; //
import { Route as SimilarCasesListRoute } from './SimilarCases/List';
import { Route as ObservablesListRoute } from './Observables/List'; //
import { Route as RespondersListRoute } from './Responders/List'; //
import { Route as ObservablesDetailsRoute } from './Observables/Details';
import { RouteWithReport as ObservablesDetailsReportRoute } from './Observables/Details';
import { Route as LinkedAlertsListRoute } from './LinkedAlerts/List'; //
import { Route as TasksListRoute } from './Tasks/List'; //
import { Route as TasksDetailsRoute } from './Tasks/Details';
import { Route as TTPListRoute } from './TTP/List';
import { Route as SimilarAlertsListRoute } from './SimilarAlerts/List';
import { Route as PagesRoute, RouteDetails as PageRoute } from './Pages/';
import { Route as TimelineRoute } from './Timeline';
import { Route as HistoryRoute } from './History/List';

export default [
    DescriptionRoute,

    TasksDetailsRoute,
    TasksListRoute,

    ObservablesDetailsReportRoute,
    ObservablesDetailsRoute,
    ObservablesListRoute,

    TTPListRoute,

    AttachmentSectionListRoute,
    AttachmentListRoute,

    TimelineRoute,

    PagesRoute,
    PageRoute,

    SimilarCasesListRoute,

    SimilarAlertsListRoute,

    LinkedAlertsListRoute,

    RespondersListRoute,

    HistoryRoute,
];
